import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../api'

// Types
export interface Drop {
  id: number
  title: string
  videoUrl: string
  thumbnailUrl?: string
  tags?: string
  companyId?: string | null
  company?: { id: string; name: string } | null
  createdBy: string
  status: 'draft' | 'published'
  order: number
  createdAt: string
  updatedAt: string
  _count: { drop_likes: number; drop_views: number }
}

export interface CreateDropDTO {
  title: string
  videoUrl: string
  thumbnailUrl?: string
  tags?: string
  companyId?: string | null
  status?: 'draft' | 'published'
  order?: number
}

export interface UpdateDropDTO {
  title?: string
  videoUrl?: string
  thumbnailUrl?: string
  tags?: string
  status?: 'draft' | 'published'
  order?: number
}

// Admin hooks
export function useAdminDrops(enabled = true) {
  return useQuery({
    queryKey: ['admin-drops'],
    queryFn: async () => {
      const { data } = await api.get<Drop[]>('/admin/drops')
      return data
    },
    enabled,
  })
}

export function useCreateDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (dto: CreateDropDTO) => {
      const { data } = await api.post<Drop>('/admin/drops', dto)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-drops'] })
    },
  })
}

export function useUpdateDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, ...dto }: UpdateDropDTO & { id: number }) => {
      const { data } = await api.put<Drop>(`/admin/drops/${id}`, dto)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-drops'] })
    },
  })
}

export function useDeleteDrop() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await api.delete(`/admin/drops/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-drops'] })
    },
  })
}
